module.exports = __webpack_public_path__ + "img/harold_squarepants.61f54507.jpg";